import { apiSlice } from "../../app/api/apiSlice";

export const schoolApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getSchools: builder.query({
      query: () => "/schools",
      providesTags: ["School"],
    }),
    getSchoolById: builder.query({
      query: (id) => `/schools/${id}`,
      providesTags: (result, error, id) => [{ type: "School", id }],
    }),
    createSchool: builder.mutation({
      query: (data) => ({
        url: "/schools",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["School"],
    }),
    updateSchool: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/schools/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [
        "School",
        { type: "School", id },
      ],
    }),
    deleteSchool: builder.mutation({
      query: (id) => ({
        url: `/schools/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["School"],
    }),
  }),
});

export const {
  useGetSchoolsQuery,
  useGetSchoolByIdQuery,
  useCreateSchoolMutation,
  useUpdateSchoolMutation,
  useDeleteSchoolMutation,
} = schoolApiSlice;
